"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _queryString = _interopRequireDefault(require("query-string"));

var _bridge = _interopRequireDefault(require("../bridge"));

var _Authentication = _interopRequireDefault(require("../Authentication"));

var _api = _interopRequireDefault(require("../actions/api"));

require("../styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var defaultConfig = {
  loginServer: "https://central.sarstuff.co.uk",
  applicationRoot: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "") + "/"
};

var Loader = function Loader(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: "1rem",
      textAlign: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null)), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: "block"
    }
  }, props.children));
};

var Segment = function Segment(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: "1rem",
      textAlign: "center"
    }
  }, props.children);
};

var Message = function Message(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loginWidget-alert ".concat(props.info !== undefined && "loginWidget-alert-info", " ").concat(props.negative !== undefined && "loginWidget-alert-negative", " ").concat(props.warning !== undefined && "loginWidget-alert-warning")
  }, props.children);
};

var AuthenticationWrapper = /*#__PURE__*/function (_Component) {
  _inherits(AuthenticationWrapper, _Component);

  var _super = _createSuper(AuthenticationWrapper);

  function AuthenticationWrapper(props) {
    var _this;

    _classCallCheck(this, AuthenticationWrapper);

    _this = _super.call(this, props);
    _this.state = {
      redirect: false,
      reload: false,
      processing: false,
      loading: true,
      loggedIn: false,
      error: false,
      user: {},
      access_token: ""
    };

    _bridge.default.setConfig(_objectSpread(_objectSpread({}, defaultConfig), props.config));

    _Authentication.default.setComponent(_assertThisInitialized(_this));

    _bridge.default.setContextHandlers(props.dynamicScopes || {});

    return _this;
  }

  _createClass(AuthenticationWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      _bridge.default.setConfig(_objectSpread(_objectSpread({}, defaultConfig), this.props.config)); // Just in case any of the config options were changed after we have already mounted the config


      _bridge.default.setContextHandlers(this.props.dynamicScopes || {});
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var urlParams = _queryString.default.parse(window.location.search);

      if (urlParams.code !== undefined) {
        this.setState({
          processing: true
        }, function () {
          _this2.login(urlParams.code);
        });
        return;
      } else {
        this.setState({
          redirect: true
        });
      }

      this.checkLogin();
    }
  }, {
    key: "checkLogin",
    value: function checkLogin() {
      var _this3 = this;

      var config = _bridge.default.getRAWConfig();

      var access_token = localStorage.getItem(config.localPrefix + "access_token");

      if (access_token !== undefined && access_token !== null) {
        _api.default.auth.user_details(access_token).then(function (res) {
          _Authentication.default.setUserData(res);

          _Authentication.default.setUserScopes(res.scopes);

          _Authentication.default.setAccessToken(access_token);

          localStorage.setItem(config.localPrefix + "access_token", access_token);

          try {
            _this3.setState({
              user: res,
              loading: false,
              loggedIn: true,
              access_token: access_token
            });
          } catch (e) {
            console.error(e);
          }
        }).catch(function (err) {
          console.error(err);
          localStorage.removeItem(config.localPrefix + "access_token");

          _this3.setState({
            loading: false,
            loggedIn: false,
            user: {},
            access_token: ""
          });
        });
      } else {
        localStorage.removeItem(config.localPrefix + "access_token");
        this.setState({
          loading: false,
          loggedIn: false,
          user: {},
          access_token: ""
        });
      }
    }
  }, {
    key: "login",
    value: function login(code) {
      var _this4 = this;

      _api.default.auth.exchange_code(code).then(function (res) {
        _api.default.auth.user_details(res.access_token).then(function (details) {
          _Authentication.default.setUserData(details);

          _Authentication.default.setAccessToken(res.access_token);

          _Authentication.default.setUserScopes(details.scopes);

          var config = _bridge.default.getRAWConfig();

          localStorage.setItem(config.localPrefix + "access_token", res.access_token);

          _this4.setState({
            user: details,
            loading: false,
            processing: false,
            loggedIn: true,
            reload: true,
            access_token: res.access_token
          });
        });
      }).catch(function (err) {
        if (err.response) {
          if (err.response.status === 401) {
            if (err.response.data.error === "invalid_code") {
              _this4.setState({
                loading: false,
                loggedIn: false,
                processing: false,
                user: {},
                access_token: "",
                error: "Code Expired"
              });

              return;
            } else if (err.response.data.error === "access_denied") {
              _this4.setState({
                loading: false,
                loggedIn: false,
                processing: false,
                user: {},
                access_token: "",
                error: "Not Allowed"
              });

              return;
            }
          }

          _this4.setState({
            loading: false,
            loggedIn: false,
            processing: false,
            user: {},
            access_token: "",
            error: "Network Issue"
          });

          return;
        }

        _this4.setState({
          loading: false,
          loggedIn: false,
          processing: false,
          user: {},
          access_token: "",
          error: "Unknown Issue"
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this5 = this;

      _api.default.auth.logout().then(function (res) {
        _Authentication.default.setAccessToken(null);

        _Authentication.default.setUserData(null);

        _Authentication.default.setUserScopes([]);

        var config = _bridge.default.getRAWConfig();

        localStorage.removeItem(config.localPrefix + "access_token");

        _this5.setState({
          loading: false,
          loggedIn: false,
          user: {},
          access_token: ""
        });
      }).catch(function (e) {
        console.error(e);
      });
    }
  }, {
    key: "getLoginURL",
    value: function getLoginURL() {
      var config = _bridge.default.getRAWConfig();

      return config.loginServer + "/oauth/authorize?client_id=" + config.clientId + "&redirect_uri=" + config.applicationRoot + "&response_type=code&scope=profile";
    }
  }, {
    key: "render",
    value: function render() {
      var config = _bridge.default.getRAWConfig();

      if (this.state.reload) {
        window.location = config.applicationRoot;
        return /*#__PURE__*/_react.default.createElement(Loader, null, "Reloading Application...");
      }

      if ((config.clientId === undefined || config.localPrefix === undefined || config.applicationServer === undefined) && process.env.NODE_ENV !== "production") {
        return /*#__PURE__*/_react.default.createElement(Segment, null, /*#__PURE__*/_react.default.createElement(Message, {
          negative: true
        }, /*#__PURE__*/_react.default.createElement("h1", null, "Error"), /*#__PURE__*/_react.default.createElement("br", null), "There is a misconfiguration with the AuthenticationWrapper. Please ensure: 'clientId', 'localPrefix' & 'applicationServer' are set and passed via the config prop."));
      }

      if (this.state.error) {
        if (this.state.error === "Not Allowed") {
          return /*#__PURE__*/_react.default.createElement(Segment, null, /*#__PURE__*/_react.default.createElement(Message, {
            negative: true
          }, /*#__PURE__*/_react.default.createElement("h1", null, "Access Denied"), /*#__PURE__*/_react.default.createElement("br", null), "Your SarStuff Central account and/or organisation does not have the correct access rights to login into this application therefore access has been denied.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), "If you believe that you should have access to this application then please contact your Organisation Admins to obtain access. Otherwise please send an email to: ", /*#__PURE__*/_react.default.createElement("strong", null, "support@sarstuff.co.uk")), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("button", {
            onClick: function onClick() {
              return window.location = "/";
            },
            className: "loginWidget-button-success"
          }, "Retry Login"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(Message, {
            info: true
          }, /*#__PURE__*/_react.default.createElement("h3", null, "Things To Check:"), /*#__PURE__*/_react.default.createElement("br", null), "1. ", /*#__PURE__*/_react.default.createElement("strong", null, "Are you logging into the correct application?"), " A few of our systems have unique website addresses that are organisation specific, check the website address above is correct for your organisation.", /*#__PURE__*/_react.default.createElement("br", null), "2. ", /*#__PURE__*/_react.default.createElement("strong", null, "Insufficient security groups assigned to your account?"), " You may not have the correct security groups assigned to your SarStuff Central account to grant you access to this application.", /*#__PURE__*/_react.default.createElement("br", null), "3. ", /*#__PURE__*/_react.default.createElement("strong", null, "Application not enabled for organisation?"), " Your organisation might not have access to this application, please contact: sales@sarstuff.co.uk if you think this is in error."));
        } else if (this.state.error === "Code Expired") {
          return /*#__PURE__*/_react.default.createElement(Segment, null, /*#__PURE__*/_react.default.createElement(Message, {
            warning: true
          }, /*#__PURE__*/_react.default.createElement("h1", null, "Session Expired"), /*#__PURE__*/_react.default.createElement("br", null), "It appears that your login session has expired. You must re-authenticate before continuing."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("button", {
            onClick: function onClick() {
              return window.location = "/";
            },
            className: "loginWidget-button-success"
          }, "Login"));
        }

        return /*#__PURE__*/_react.default.createElement(Segment, null, /*#__PURE__*/_react.default.createElement(Message, {
          negative: true
        }, /*#__PURE__*/_react.default.createElement("h1", null, "Service Error"), /*#__PURE__*/_react.default.createElement("br", null), "We were unable to log you into the application as this time. This could be due to a temporary server issue or a problem with your internet connection. Please try again in a few moments. If the issue continues contact SarStuff support at: ", /*#__PURE__*/_react.default.createElement("strong", null, "support@sarstuff.co.uk")), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("button", {
          onClick: function onClick() {
            return window.location = "/";
          },
          className: "loginWidget-button-success"
        }, "Login"));
      }

      if (this.state.processing) {
        return /*#__PURE__*/_react.default.createElement(Loader, null, "Processing Login...");
      }

      if (this.state.loading) {
        return /*#__PURE__*/_react.default.createElement(Loader, null, "Loading...");
      }

      if (!this.state.loggedIn) {
        if (this.state.redirect) {
          window.location = this.getLoginURL();
          return /*#__PURE__*/_react.default.createElement(Loader, null, "Redirecting to SarStuff Central...");
        }

        return /*#__PURE__*/_react.default.createElement(Loader, null, "Processing Login...");
      } else {
        return this.props.children;
      }
    }
  }]);

  return AuthenticationWrapper;
}(_react.Component);

exports.default = AuthenticationWrapper;